import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import config from 'garaje/config/environment';

export default class ScreensRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  beforeModel(): void {
    if (this.abilities.cannot('visit screens')) {
      return void this.router.transitionTo('unauthorized');
    }

    if (config.environment === 'test') {
      return;
    }

    const { cookieDomain } = config;
    const domain = cookieDomain.includes('christmas') ? `apps.${cookieDomain}` : cookieDomain;

    const PRELOAD_APPS = [
      'screens-device-list',
      'screens-content-list',
      'screens-playlist-list',
      'screens-add-screen',
      'screens-add-import',
      'screens-add-public-url',
      'screens-studio',
      'screens-schedule-list',
      'screens-schedule-editor',
    ];

    PRELOAD_APPS.map((app) => {
      void import(/* webpackIgnore: true */ `https://sapi.${domain}/s/${app}`);
    });

    if (this.abilities.cannot('view devices screens')) {
      return void this.router.transitionTo('screens.playlists.index');
    }
  }
}
